import axios from 'axios'
import { defaultError, WebError } from "@hybird/core/error";
import "@hybird/core/lib"


/**
 * @type {axios.AxiosInstance}
 */
const service = axios.create({
  // TODO 后续完成后记得改过来
  baseURL: process.env.VUE_APP_API_BASE_URL, // baseURL: 'https://uatapi.libawall.com',
  timeout: 60 * 1000, withCredentials: false, // 允许携带cookie
  maxRedirects: 5,
})

const sessionIdKey = "sessionid"
service.interceptor = true;
service.debug = false;

let controller;
const abortRequest = (val) => {
  if (controller) {
    controller.abort(val || 'Request canceled ');
    controller = null;
  }
}

/**
 *
 * @param url{string}
 * @param data{{}}
 * @param config{axios.AxiosRequestConfig}
 * @return {Promise<axios.AxiosResponse<any>>}
 */
service.getFrom = (url, data = null, config = {}) => {
  config.params = data;
  return service.get(url, config);
}

// 异常处理
export const errorRequest = (err) => {
  console.error('请求异常', err)

  if (!(err instanceof RequestError)) {
    err = WebError.error(err, defaultError.REQUEST_ERROR);
  }

  return Promise.reject(err);
}

function setSessionId(sessionId) {
  if (sessionId) {
    localStorage.setItem(sessionIdKey, sessionId);
    service.defaults.headers.common[sessionIdKey] = sessionId;
  } else {
    delete service.defaults.headers.common[sessionIdKey];
    localStorage.removeItem(sessionIdKey);
  }
}


function setHeader(headName, value) {
  if (value) {
    service.defaults.headers.common[headName] = value;
  } else {
    delete service.defaults.headers.common[headName];
  }
}

service.local = false
//初始化sessionId
setSessionId(localStorage.getItem(sessionIdKey));
service.interceptors.request.use((request) => {
  /**
   * @type{String}
   */
  const url = request.url;
  console.log(request.url);
  const requestData = {
    url: request.url,
    method: request.method,
    params: request.params,
    data: request.data,
  }
  controller = new AbortController();
  request.signal = controller.signal;

  console.log('请求参数打印', JSON.stringify(requestData));
  if (url.includes("img.yda.cn") && service.local) {
    let origin = location.origin;
    if (!origin.includes("localhost")) {
      origin = "http://localhost:10800";
    }
    request.url = `${origin}/proxy?url=${encodeURIComponent(request.url)}`;
  }

  return request;
})
// 响应拦截器
service.interceptors.response.use(async (response) => {
  const sessionId = response.headers[sessionIdKey];
  if (sessionId) {
    setSessionId(sessionId);
  }

  const contentType = response.headers['content-type'];

  if (service.debug) {
    console.log("请求结果requestData打印=", response.request.host + response.request.path, response.request.headers, response.headers, response.config.data, response.data)
  }

  if (service.interceptor && contentType && contentType.startsWith("application/json")) {
    const {
      code, success, message
    } = response.data;
    if (!success) {
      if (code === 601) {
        setSessionId();
      }

      throw RequestError.code(defaultError.REQUEST_ERROR, {
        msg: message, data: response.data
      });
    }

    return response.data
  } else {
    return response;
  }
}, errorRequest)


export default service;

if (process.env.VUE_APP_API_VERSION) {
  setHeader("endpointVersion", `v${process.env.VUE_APP_API_VERSION}`)
}

class RequestError extends WebError {

}

export {
  setSessionId, setHeader, RequestError, abortRequest
}